<template>
  <div>
    <VNotification
      :item="notification"
      @toggle-read="$emit('toggle-read',notification)"
      @close="$emit('close')"
    >
      <template #header>
        <span>
          {{ $t('notification_PathwaySharedToManager', { name: notification.data.sharedByName }) }}:
        </span>
        <span>
          {{ notification.data.pathwayName }}
        </span>
      </template>
      <template #content>
        <div
          class="text-link cursor-pointer"
          @click="onClick"
        >
          {{ $t('view_path') }}
        </div>
      </template>
    </VNotification>
  </div>
</template>

<script>
// Components
import VNotification from '@/components/templates/notifications/VNotification';
import router from '@/router';
export default {
  components: {
    VNotification
  },
  props: {
    notification: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['toggle-read', 'close'],
  setup (props, context) {
    const onClick = () => {
      if (props.notification.data.reportsToId) {
        router.push({
          name: 'my-teams-id-member-career-paths',
          params: {
            id: props.notification.data.sharedByUser.id,
            parent: props.notification.data.reportsToId
          }
        });
      } else {
        router.push({
          name: 'my-profile-career-paths'
        });
      }

      context.emit('close');
    };

    return {
      onClick
    };
  }
};
</script>
